import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import { API } from "../../App";
import { toast } from "react-toastify";
import Switch from "react-switch";
import Cookies from "js-cookie";

const KeyboardCategoriesAdd = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  // const [selectedfile, setSelectedfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(true);

  const [category, setCategory] = useState({
    name: "",
    // image: "",
    status: true,
  });

  const { name } = category;

  const handleSubmission = async () => {
    if (!name) {
      setValidate(true);
      return;
    }
    // if (!selectedfile) {
    //   toast.error("Please select an image", { position: "bottom-right" })
    //   return
    // }

    const formdata = new FormData();
    formdata.append("name", name);
    // formdata.append("image", selectedfile)
    formdata.append("status", status);

    setLoading(true);
    try {
      const token = Cookies.get("jwt");
      const res = await API.post("/keyboardCategories/add", formdata, {
        headers: { authorization: `Bearer ${token}` },
      });

      if (res.data.status === true) {
        navigate("/keyboard/category");
        toast.success("Keyboard category added successfully", {
          position: "bottom-right",
          autoClose: 500,
        });
      }
    } catch (error) {
      toast.error("Error adding keyboard category", {
        position: "bottom-right",
      });
    } finally {
      setLoading(false);
    }
  };

  const onInputChange = (e) => {
    setCategory({ ...category, [e.target.name]: e.target.value });
  };

  // const handleFileChange = (event) => {
  //   setSelectedfile(event.target.files[0])
  //   setIsSelected(true)
  // }

  const handleStatusChange = (checked) => {
    setStatus(checked);
  };

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Add Keyboard Category</h3>
      </div>
      <div className="page-content">
        <Form noValidate validated={validate}>
          <Row>
            <Col xs={12}>
              <Card className="mb-4">
                <Card.Body>
                  {loading && <div className="loader table-loader"></div>}
                  <Row>
                    <Col lg={4} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="name">Name</Form.Label>
                        <Form.Control
                          type="text"
                          id="name"
                          name="name"
                          value={name}
                          onChange={onInputChange}
                          placeholder="Enter category name"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter a name
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={4} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="image">Image</Form.Label>
                        <InputGroup>
                          <Form.Control 
                            type="file" 
                            id="image" 
                            name="image" 
                            onChange={handleFileChange}
                            required 
                          />
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">
                          Please select an image
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col lg={4} sm={12}>
                      <Form.Label htmlFor="status" className="d-block mb-2">
                        Status
                      </Form.Label>
                      <Switch
                        onChange={handleStatusChange}
                        checked={status}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className="react-switch-off">OFF</div>
                        }
                        checkedIcon={<div className="react-switch-on">ON</div>}
                      />
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer className="text-end">
                  <Button
                    variant="primary"
                    className="me-3"
                    onClick={handleSubmission}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </Button>
                  <Link to="/keyboard/category">
                    <Button variant="secondary">Cancel</Button>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Layout>
  );
};

export default KeyboardCategoriesAdd;
